module.exports = __webpack_public_path__ + "img/jht-icon-31.050a8308.png";